import React, { useRef } from "react";
import { Routes, Route } from "react-router-dom";

// Layouts
import EmptyLayout from "../layouts/EmptyLayout";
import ApplicationLayout from "../layouts/ApplicationLayout";

//Components
import emptyLayoutRoutes from "./router components/emptyLayoutRoutes";
import applicationLayoutRoutes from "./router components/applicationLayoutRoutes";
import authLayoutRoutes from "./router components/authLayoutRoutes";
import AuthLayout from "../layouts/AuthLayout";
export default function Router() {
  const allRoutes = useRef([
    {
      ID: "applicationLayoutRoutes",
      path: "/",
      layout: ApplicationLayout,
      children: allChildrenRoutes(applicationLayoutRoutes),
    },

    {
      ID: "authLayoutRoutes",
      path: "/",
      layout: AuthLayout,
      children: allChildrenRoutes(authLayoutRoutes),
    },

    {
      ID: "emptyLayoutRoutes",
      path: "/",
      layout: EmptyLayout,
      children: allChildrenRoutes(emptyLayoutRoutes),
    },
  ]);

  return (
    <Routes>
      {allRoutes.current.map(
        ({ ID: layoutID, path, layout: Layout, children }) =>
          layoutID && (
            <Route key={layoutID} path={path} element={<Layout />}>
              {children.map(
                ({ ID: pageID, index, path, element: Element, disableAuth }) =>
                  pageID && (
                    <Route
                      key={pageID}
                      index={!!index}
                      path={path}
                      element={
                        <Element pageID={pageID} disableAuth={!!disableAuth} />
                      }
                    />
                  )
              )}
            </Route>
          )
      )}
      <Route path="*" element={<div>Page Not Found</div>} />
    </Routes>
  );
}

function allChildrenRoutes(parentObject) {
  const childrenArray = [];

  for (var key in parentObject) {
    childrenArray.push(parentObject[key]);
  }

  return childrenArray;
}
